(function () {
  const sections = Array.from(document.querySelectorAll('[data-about-3d-headline]'));
  if (!sections.length) return;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const resetIntroScroll = () => {
    const firstSection = sections[0];
    const shopifySection = firstSection.closest('.shopify-section');
    const firstPageSection = document.querySelector('#xo-main-content > .shopify-section');

    if (!shopifySection || shopifySection !== firstPageSection || window.location.hash) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  };

  const applyReducedMotion = (section) => {
    const viewers = section.querySelectorAll('model-viewer');
    viewers.forEach((viewer) => {
      if (motionQuery.matches) {
        viewer.removeAttribute('auto-rotate');
      } else if (section.dataset.autoRotate === 'true') {
        viewer.setAttribute('auto-rotate', '');
        const speed = getComputedStyle(section).getPropertyValue('--a3h-rotation-speed').trim() || '30deg';
        viewer.setAttribute('rotation-per-second', speed);
      }
    });
  };

  const resolveScrollTarget = (section) => {
    const selector = section.dataset.scrollTarget;
    if (selector) {
      try {
        return document.querySelector(selector);
      } catch {
        return null;
      }
    }

    const currentSection = section.closest('.shopify-section');
    if (!currentSection) return null;

    let sibling = currentSection.nextElementSibling;
    while (sibling) {
      if (sibling.classList.contains('shopify-section')) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }

    return null;
  };

  const scrollToTarget = (target) => {
    if (!target) return;

    const header = document.querySelector('.header-humm, .section-header-humm, header');
    const headerOffset = header ? header.getBoundingClientRect().height : 0;
    const top = window.scrollY + target.getBoundingClientRect().top - headerOffset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: motionQuery.matches ? 'auto' : 'smooth',
    });
  };

  sections.forEach((section) => {
    applyReducedMotion(section);

    const button = section.querySelector('[data-about-3d-scroll]');
    if (!button) return;

    button.addEventListener('click', () => {
      scrollToTarget(resolveScrollTarget(section));
    });
  });

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', () => {
      sections.forEach(applyReducedMotion);
    });
  } else if (typeof motionQuery.addListener === 'function') {
    motionQuery.addListener(() => {
      sections.forEach(applyReducedMotion);
    });
  }

  resetIntroScroll();
})();
